// This file was auto-generated by Fern from our API Definition.
export var McpoAuthConfig;
(function (McpoAuthConfig) {
    McpoAuthConfig.TokenEndpointAuthMethod = {
        ClientSecretBasic: "client_secret_basic",
        ClientSecretPost: "client_secret_post",
        None: "none",
    };
})(McpoAuthConfig || (McpoAuthConfig = {}));
